<template>
	<div class="popover dark text-gray-400">
		<main class="overflow-y-auto overflow-x-hidden visible-scrollbars">
			<slot name="header">
				<h3 v-if="title" class="popover-heading truncate">{{ title }}</h3>
			</slot>
			<!-- default  -->
			<slot />
		</main>
		<!-- footer  -->
		<footer v-if="$slots.footer" class="mt-4">
			<hr class="border-gray-600" />
			<slot name="footer" />
		</footer>
	</div>
</template>

<script>
export default {
	name: 'BasePopover',
	props: {
		title: {type: String, default: ''},
	},
}
</script>
